module.exports = __webpack_public_path__ + "img/tick.1c97e8c0.svg";